import React, {Fragment} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileContract,  faFilePdf} from "@fortawesome/free-solid-svg-icons";
import { setLimpiarRecibos } from '../actions/busqueda/busquedaReciboAction';

const RecibosCliente = (props) => {
    const dispatch = useDispatch();
    const facturas = useSelector(state => state.recibos.relaciones);
    console.log(facturas);

    const Facturas = () => {
        return facturas && facturas.length > 0 && facturas.map((factura, i) => (
            <tbody>
                <tr key={i}>
                    <td className="center">{i + 1}</td>
                    <th>{factura.tipo}</th>
                    <th className="right">{factura.fecha}</th>
                    <th className="center">{factura.moneda}</th>
                    <th className="right">{Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(factura.importe)}</th>
                    {/* <th className="right">{factura.numOperacion}</th> --AJ7, 31/01/23 */}
                    <th className="right">{factura.ubicacion}</th>
                    <th className="center">
                        <a href={factura.xmlUrl} target='_blank'>
                            <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                icon={faFileContract}/>
                        </a>
                    </th>
                    <th className="center">
                        <a href={factura.pdfUrl} target='_blank'>
                            <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                icon={faFilePdf}/>
                        </a>
                    </th>
                </tr>
            </tbody>
        ))
    };

    return (
        <Fragment>
            <h3>Facturas del Cliente</h3>
            <p className="mb-40">Valide su información.</p>
            <div className="table-responsive-sm mb-40">
                <table className="table table-active table-bordered" style={{"fontSize": "14px"}}>
                    <thead className="thead-dark">
                        <tr>
                            <th className="center">#</th>
                            <th>Tipo</th>
                            <th className="right">Fecha</th>
                            <th className="center">Moneda</th>
                            <th className="right">Importe</th>
                            {/* <th className="right">Número de operación</th> --AJ7, 31/01/23 */}
                            <th className="right">Ubicación</th>
                            <th className="right">Archivo XML</th>
                            <th className="right">Archivo PDF</th>
                        </tr>
                    </thead>
                    
                    <Facturas />
                </table>
            </div>
            <div className="row">
                <div className="col-xs-12 col-md-3">
                    <button className="btn btn-lg btn-chapur btn-block" onClick={() => {
                        dispatch(setLimpiarRecibos());
                        props.previousStep();
                    }}>
                        Regresar
                    </button>
                </div>
            </div>
        </Fragment>);
};

export default RecibosCliente;